import React from "react";
import { SimpleForm, required, TextInput } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { FormToolbar } from "../../common/form/FormToolbar";
import "../../common/styles/form-style.css";

interface Props {}

export const EldForm = (props: Props) => {
  return (
    <SimpleForm
      {...props}
      variant="outlined"
      className="form-create-edit"
      toolbar={<FormToolbar showDeleteButton={false} />}>
      <ProtectedElement source="serialNumber">
        <TextInput
          source="serialNumber"
          label="resources.admin-elds.labels.serialNumber"
          validate={required()}
        />
      </ProtectedElement>
      <ProtectedElement source="vendor">
        <TextInput source="vendor" label="resources.admin-elds.labels.vendor" />
      </ProtectedElement>
    </SimpleForm>
  );
};
